import React from "react";
import { useLoader } from "../../context/LoaderContext";

const GlobalLoader = () => {
  const { isLoading } = useLoader();

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-[1111] flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-xl p-6 w-80 text-center">
        <div className="relative w-full h-2 bg-gray-200 rounded-full overflow-hidden mb-4">
          <div className="absolute inset-y-0 left-0 w-1/3 bg-black animate-slide"></div>
        </div>
        <p className="text-black font-semibold">Downloading assets...</p>
      </div>
    </div>
  );
};

export default GlobalLoader;